import { useRef, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import moment from 'moment';

import { useLanguage } from '../../../../Context/LanguageContext';

// Model //
import FetchModule from '../../../Share/Network/FetchModule.js';
import IndividualInfo from './IndividualInfo.js';
import HistoryView from './HistoryView.js';
// Model //

export default function MemberDetailView(props) {
  const { memberId, division } = props;
  const { t } = useLanguage();

  const history = useHistory();

  const [memberData, setMemberData] = useState([{
    name: '',
    birthDay: '',
    gender: '',
    linkCoachId: '',
    phone: '',
    profile: 'None'
  }]);
  const [failedSubscriptMemberships, setFailedSubscriptMemberships] = useState([]);
  const [memberShipData, setMemberShipData] = useState([]);
  const [totalMemberShips, setTotalMemberShips] = useState([]);
  const [lessonHistoryData, setLessonHistoryData] = useState([]);
  const [totalHistoryData, setTotalHistoryData] = useState([]);
  const [lockerData, setLockerData] = useState([]);
  const [productUsages, setProductUsages] = useState([]);
  const [totalPoint, setTotalPoint] = useState(0);
  const [pointHistories, setPointHistories] = useState([]);
  const [rendering, setRendering] = useState(false);
  const [lockerRendering, setLockerRendering] = useState(false);
  const [storeName, setStoreName] = useState('');
  const [originalMemberDetail, setOriginalMemberDetail] = useState('');
  const [recentlyLocker, setRecentlyLocker] = useState('-');

  const defaultProvisions = [
    {
      id: 0,
      isDefault: true,
      title: t('myStoreSetting.terms.defaultProvision1Title'),
      text: t('myStoreSetting.terms.defaultProvision1Text')
    },
    {
      id: 0,
      isDefault: true,
      title: t('myStoreSetting.terms.defaultProvision2Title'),
      text: t('myStoreSetting.terms.defaultProvision2Text')
    }
  ];

  const TopLevelRef = useRef();
  const IndividualRef = useRef();
  const HistoryRef = useRef();

  useEffect(() => {
    IndividualRef.current.setMemberData(memberData);
  }, [memberData])

  // 매장 이름 불러오기 //
  useEffect(() => {
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.getIndividualData('account/find', 'GET');
        if (responseData.status === 200) setStoreName(responseData.data[0]?.storeName ?? '');
      }
    )();
  }, [])

  // 회원 데이터 불러오기 //
  useEffect(() => {
    const fetchModule = new FetchModule();

    (
      async () => {
        const responseData = await fetchModule.getDataVersion2('member/detail/' + memberId, 'GET');

        if (responseData.status === 200) {
          setMemberData(responseData.data);
          setOriginalMemberDetail(responseData.data.memberDetail);
        }
        else if (responseData.status === 201) {
          alert(t('memberDetail.alertMemberNotFound'));
          history.push('/member/valid');
        }
        else if (responseData.status === 202) {
          alert(t('memberDetail.alertInvalidAccess'));
          history.push('/member/valid');
        }
        else if (responseData.status === 401) history.push('/login');
      }
    )();
  }, [memberId, rendering])

  // 회원권 데이터 불러오기 //
  useEffect(() => {
    const fetchModule = new FetchModule();

    (
      async () => {
        const responseData = await fetchModule.getDataVersion2('member/detail/membership/' + memberId, 'GET');

        if (responseData.status === 200) {
          let memberShips = responseData.data.memberShipDetails;
          const memberShipHistories = responseData.data.memberShipHistoryDates.slice();

          memberShips.map((data) => ( data.historyData = [] ));

          // desc 진행 //
          memberShips.sort(function (a, b) {
            return a.endDate > b.endDate ? -1 : a.endDate < b.endDate ? 1 : 0;
          })

          // desc 진행 //
          memberShipHistories.sort(function (a, b) {
            return a.endDate > b.endDate ? -1 : a.endDate < b.endDate ? 1 : 0;
          })

          for (let i = 0; i < memberShips.length; i++) {
            for (let j = 0; j < memberShipHistories.length; j++) {
              if (memberShips[i].usageId === memberShipHistories[j].usageId) {
                memberShips[i].historyData.push(memberShipHistories[j]);
              }
            }
          }

          const now = moment();

          const failedCandidates = memberShips
            // 1) 기본 조건 필터
            .filter(item =>
              item.isSubscriptionMembership === true &&
              item.subscribeStatus === true &&
              item.subscribeDeleted === false &&
              moment(item.endDate).isBefore(now)
            )
            // 2) 같은 구독 그룹에 활성(미만료) cycle이 있으면 제외
            .filter(item => {
              const sameGroup = memberShips.filter(
                d => d.maintainSubscriptionMembershipId === item.maintainSubscriptionMembershipId
              );
              // 같은 그룹 중 하나라도 endDate가 now 이후라면 제외
              return !sameGroup.some(d => moment(d.endDate).isSameOrAfter(now));
            });

          // 3) 구독(maintainSubscriptionMembershipId)별 endDate 최신 1건만 유지 (중복 노출 제거) //
          const latestByGroup = new Map();

          failedCandidates.forEach(item => {
            const key = item.maintainSubscriptionMembershipId;
            const prev = latestByGroup.get(key);

            if (!prev || moment(item.endDate).isAfter(moment(prev.endDate))) {
              latestByGroup.set(key, item);
            }
          });

          const newFailedSubscriptMemberships = Array.from(latestByGroup.values());

          setFailedSubscriptMemberships(newFailedSubscriptMemberships);
          setMemberShipData(memberShips);
          setTotalHistoryData(memberShipHistories);
        }
      }
    )();
  }, [memberId, rendering])
  
  // 회원권 수강내역 불러오기 //
  useEffect(() => {
    const fetchModule = new FetchModule();

    (
      async () => {
        const responseData = await fetchModule.getDataVersion2('member/detail/reserve/' + memberId, 'GET');

        if (responseData.status === 200) {
          let finalLessonHistoryData = responseData.data.slice();

          finalLessonHistoryData.sort((a, b) => {
            // 1순위: classDate
            const classDateA = moment(a.classDate);
            const classDateB = moment(b.classDate);

            if (!classDateA.isSame(classDateB)) {
              return classDateB - classDateA; // desc
            }
          
            // 2순위: classTime (HH:mm-HH:mm 또는 HH:mm)
            const startTimeA = a.classTime.split('-')[0].trim(); // 앞부분 HH:mm
            const startTimeB = b.classTime.split('-')[0].trim();
            const timeA = moment(startTimeA, 'HH:mm');
            const timeB = moment(startTimeB, 'HH:mm');

            if (!timeA.isSame(timeB)) {
              return timeB - timeA; // desc
            }
          
            // 3순위: createdDate
            const createdA = moment(a.createdDate);
            const createdB = moment(b.createdDate);
            return createdB - createdA; // desc
          });

          setLessonHistoryData(finalLessonHistoryData);
        }
      }
    )();
  }, [memberId, rendering])

  // 물품 구매내역 불러오기 //
  useEffect(() => {
    const fetchModule = new FetchModule();

    (
      async () => {
        const responseData = await fetchModule.getDataVersion2('member/detail/product/' + memberId, 'GET');

        if (responseData.status === 200) {
          setProductUsages(responseData.data);
        }
      }
    )();

  }, [memberId, rendering])

  // 회원 포인트 내역 불러오기 //
  useEffect(() => {
    const fetchModule = new FetchModule();

    (
      async () => {
        const responseData = await fetchModule.getDataVersion2('member/detail/point/' + memberId, 'GET');

        if (responseData.status === 200) {
          setTotalPoint(responseData.data.totalPoint);
          setPointHistories(responseData.data.pointHistories);
        }
      }
    )();
  }, [memberId, rendering])

  // 회원권 수강 내역 정리 //
  useEffect(() => {
    if (memberShipData.length === 0 || lessonHistoryData.length === 0) {
      setTotalMemberShips(memberShipData);
      return;
    }

    const memberShips = memberShipData.slice();
    const finalLessonHistoryData = lessonHistoryData.slice();

    for (let i = 0; i < memberShips.length; i++) {
      let usageHistoryCount = 0;
      let lastReserveDate = undefined;

      for (let j = 0; j < finalLessonHistoryData.length; j++) {
        if (memberShips[i].usageId === finalLessonHistoryData[j].usageId) {
          if (lastReserveDate === undefined
            || lastReserveDate.isBefore(moment(finalLessonHistoryData[j].classDate))) {
              lastReserveDate = moment(finalLessonHistoryData[j].classDate);
            }
          
          usageHistoryCount += finalLessonHistoryData[j].deduction;
        }
      }

      memberShips[i].lastReserveDate = lastReserveDate === undefined ? memberShips[i].endDate : lastReserveDate;
      memberShips[i].courseTakeCount = usageHistoryCount;

      if (moment(memberShips[i].endDate).isBefore(moment())
        || (memberShips[i].totalMax !== -1 && memberShips[i].totalMax <= memberShips[i].courseTakeCount)) 
          memberShips[i].isExpired = true;
      else memberShips[i].isExpired = false;
    }
    
    // 추가분 //
    memberShips.sort((a, b) => {
      if (a.isExpectedMemberShip !== b.isExpectedMemberShip) return a.isExpectedMemberShip ? -1 : 1;
      else if (a.isExpired !== b.isExpired) return a.isExpired ? 1 : -1;

      return a.endDate > b.endDate ? -1 : a.endDate < b.endDate ? 1 : 0;
    });
    // 추가분 //

    setTotalMemberShips(memberShips);
  }, [memberShipData, lessonHistoryData])

  // 락커 데이터 정리 //
	useEffect(() => {
    const fetchModule = new FetchModule();

    (
      async () => {
        const responseData = await fetchModule.getDataVersion2('locker/' + memberId, 'GET');
        
        if (responseData.status === 200) {
          const nowTs = Date.now();

          // lockerId 기준으로 그룹화 //
          const groupedByLockerId = {};

          for (let i = 0; i < responseData.data.length; i++) {
            const item = responseData.data[i];
            const id = item.lockerId;

            if (!groupedByLockerId[id]) {
              groupedByLockerId[id] = {
                lockerId: id,
                lockerName: item.lockerName,
                usages: []
              };
            }
            groupedByLockerId[id].usages.push(item);
          }

          const groupedList = [];
          const groupValues = Object.values(groupedByLockerId);

          for (let i = 0; i < groupValues.length; i++) {
            const group = groupValues[i];

            // priority 버킷 정렬 //
            // 1순위: startDate < now < endDate (현재 사용중)
            // 2순위: now < startDate (예정)
            // 3순위: endDate < now (만료)
            const buckets = [[], [], [], []];

            let representative = null;
            let repPriority = 999;

            for (let j = 0; j < group.usages.length; j++) {
              const item = group.usages[j];

              const startTs = new Date(item.startDate).getTime();
              const endTs = new Date(item.endDate).getTime();

              let priority = 4;

              if (startTs < nowTs && nowTs < endTs) priority = 1;
              else if (nowTs < startTs) priority = 2;
              else if (endTs < nowTs) priority = 3;

              const enriched = { ...item, _priority: priority };

              buckets[priority - 1].push(enriched);

              if (priority < repPriority) {
                repPriority = priority;
                representative = enriched;
              }
            }

            const sortedUsages = buckets[0].concat(buckets[1], buckets[2], buckets[3]);
            const sortKey = new Date(representative.scheduledEndDate).getTime();

            // 대표 데이터 제외한 나머지를 otherUsages로 //
            const otherUsages = sortedUsages.filter(item => item.usageId !== representative.usageId);

            groupedList.push({
              ...representative,
              lockerName: group.lockerName,
              otherUsages: otherUsages,
              sortKey: sortKey
            });
          }

          // desc 진행 //
          // 1순위: 사용중이 위로, 사용 종료가 아래로
          // 2순위: scheduledEndDate 늦은 순
          // 3순위: usageId 높은 순
          groupedList.sort(function (a, b) {
            const aIsUsing = a.status === '사용중' ? 0 : 1;
            const bIsUsing = b.status === '사용중' ? 0 : 1;

            if (aIsUsing !== bIsUsing) return aIsUsing - bIsUsing;

            if (a.sortKey !== b.sortKey) return b.sortKey - a.sortKey;
            return (b.usageId ?? 0) - (a.usageId ?? 0);
          });

          // 사용중인 락커 중 가장 최신 락커 이름 추출 //
          const usingLockers = groupedList.filter(locker => locker.status === '사용중');
          
          if (usingLockers.length > 0) setRecentlyLocker(usingLockers[0].lockerName);
          else setRecentlyLocker('-');

          setLockerData(groupedList);
        }
      }
    )();
	}, [history, lockerRendering])

  return (
    <TopLevelWrapper ref={TopLevelRef}>
      <IndividualInfo
        ref={IndividualRef}
        memberData={memberData}
        originalMemberDetail={originalMemberDetail}
        setOriginalMemberDetail={setOriginalMemberDetail}
        recentlyLocker={recentlyLocker}
        rendering={() => setRendering(prev => !prev)}/>
      <HistoryView
        ref={HistoryRef}
        memberId={memberId}
        memberData={memberData}
        storeName={storeName}
        memberShipData={totalMemberShips}
        holdingData={totalHistoryData}
        failedSubscriptMemberships={failedSubscriptMemberships}
        division={division}
        lessonHistoryData={lessonHistoryData}
        lockerData={lockerData}
        productUsages={productUsages}
        totalPoint={totalPoint}
        pointHistories={pointHistories}
        defaultProvisions={defaultProvisions}
        rendering={() => setRendering(prev => !prev)}
        lockerRendering={() => setLockerRendering(prev => !prev)}/>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;
  
  margin-left: 10px;

  transition: all 0.3s ease-in-out;
`;
